import ReplyChat from '../../replyChat';
import MarketPost from '../marketpost';
import WantedPostCard from '../wantedPost';

export const replyChatConvert: Record<
  string,
  (chat: UserMessagesResults) => JSX.Element
> = {
  market_post: chat => {
    return (
      <>
        {chat.market_post?.detail?.post_detail && (
          <MarketPost
            post={chat?.market_post}
            type={chat.market_post?.detail?.post_detail.type}
          />
        )}
      </>
    );
  },
  post: chat => {
    return (
      <ReplyChat
        created={chat.created_at}
        img={
          chat?.post?.detail?.image?.image
            ? chat?.post?.detail?.image?.image
            : null
        }
        title={chat?.post?.detail.title ? chat?.post?.detail.title : ''}
      />
    );
  },
  wanted: chat => {
    return (
      <>
        <ReplyChat
          created={chat.created_at}
          img={
            chat?.post?.detail?.image?.image
              ? chat?.post?.detail?.image?.image
              : null
          }
          title={chat?.post?.detail.title ? chat?.post?.detail.title : ''}
        />
      </>
    );
  },
  market_wanted: chat => {
    return (
      <>
        {chat.market_post?.detail?.wanted_detail && (
          <WantedPostCard
            city={chat.market_post?.detail?.wanted_detail.city}
            state={chat.market_post?.detail?.wanted_detail.state}
            createdAt={chat.market_post?.detail?.wanted_detail.created_at}
            icon={
              chat.market_post?.detail?.wanted_detail?.product_category.icon
            }
            quality={chat.market_post?.detail?.wanted_detail.quality}
            title={chat.market_post?.detail?.wanted_detail.title}
          />
        )}
      </>
    );
  },
};
